import React, { useContext, useEffect, useMemo, useRef } from 'react';
import styles from './AccountMonitoredStatus.module.scss';
import classNames from 'classnames/bind';
import { CustomerServiceDashboardContext, getMonitoringStatusAccountList } from '../../context';
import { get } from 'lodash';
import { MonitoringStatusItem } from '../../../../Controllers/CustomerServiceDashboard/CustomerServiceDashboard';
import { parseISO, differenceInHours } from 'date-fns';
import {useCustomerServiceDashboardStore} from "../../store";

const classes = classNames.bind(styles);

const AccountMonitoredStatus = () => {
    // const { state, dispatch } = useContext(CustomerServiceDashboardContext);
    const {monitoringStatusAccountList, fetchMonitoringStatusAccountList} = useCustomerServiceDashboardStore(state => state);
    /**
     * Convert a number to a percentage with no decimal places
     */
    const toPercentage = (num: number) => {
        return Math.round(num * 100);
    };

    const monitoringStats = useMemo(() => {
        const stats = { never: 0, need: 0, active: 0 };
        if (!monitoringStatusAccountList) return stats;
        monitoringStatusAccountList.forEach((account: MonitoringStatusItem) => {
            if (!account.lastUpdated || account.lastUpdated === null) {
                stats.never++;
                return;
            }
            // check if account.lastUpdate is within the last 3 hours
            const lastUpdated = parseISO(account.lastUpdated);
            const now = new Date();
            const diffInHours = differenceInHours(now, lastUpdated);
            if (diffInHours > 3) {
                stats.need++;
                return;
            }
            stats.active++;
        });
        return stats;
    }, [monitoringStatusAccountList]);

    const percentages = useMemo(() => {
        const total = monitoringStats.never + monitoringStats.need + monitoringStats.active;
        return {
            never: toPercentage(monitoringStats.never / total),
            need: toPercentage(monitoringStats.need / total),
            active: toPercentage(monitoringStats.active / total),
        };
    }, [monitoringStats]);

    // const fetchMonitoringStatusAccountList = async (abortController: AbortController) => {
    //     const { signal } = abortController;
    //     try {
    //         if (isMounted.current) dispatch({ type: 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_REQUEST' });
    //         const results = await getMonitoringStatusAccountList({ signal });
    //         if (isMounted.current) dispatch({ type: 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_SUCCESS', payload: results });
    //     } catch (error) {
    //         if (isMounted.current) dispatch({ type: 'FETCH_MONITORING_STATUS_ACCOUNT_LIST_FAILURE', payload: error });
    //     }
    // };

    useEffect(() => {
        fetchMonitoringStatusAccountList();
    }, []);
    return (
        <>
            <h4>Account Monitored Status</h4>
            <div className={classes('list')}>
                <div className={classes('item', 'never')}>
                    <div className={classes('title')}>Accounts Never Monitored</div>
                    <div className={classes('value')}>{monitoringStats.never}</div>
                    <div className={classes('percentage')}>{percentages.never}%</div>
                </div>
                <div className={classes('item', 'need')}>
                    <div className={classes('title')}>Accounts Need Monitoring</div>
                    <div className={classes('value')}>{monitoringStats.need}</div>
                    <div className={classes('percentage')}>{percentages.need}%</div>
                </div>
                <div className={classes('item', 'active')}>
                    <div className={classes('title')}>Accounts Monitored</div>
                    <div className={classes('value')}>{monitoringStats.active}</div>
                    <div className={classes('percentage')}>{percentages.active}%</div>
                </div>
            </div>
        </>
    );
};

export default AccountMonitoredStatus;
